// src/app/services/leads.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Lead } from '../modal/lead.model';
import { HttpService } from '../https.service';
import { URLUtils } from '../urlUtils';


@Injectable({
  providedIn: 'root'
})
export class LeadsService {
  private leadsSubject = new BehaviorSubject<Lead[]>([
    {
      id: 1,
      name: 'James Smith',
      type: 'Entity',
      email: 'smith@gmail.com',
      status: 'NA',
      specialization: 'NA'
    }
  ]);
  leads:any[] = [];

  public leads$ = this.leadsSubject.asObservable();
  private leadSource = new BehaviorSubject<any>(null);
  currentLead = this.leadSource.asObservable();

  constructor(private httpService: HttpService) {}

  setLead(lead: any) {
    this.leadSource.next(lead);
  }

  getLeadlist() {
    // return this.httpService.sendGetRequest(URLUtils.leadslawyers('leads')).pipe(
    //   map((response: any) => {
    //     return response.data.map((lead: any) => ({
    //       id: lead.id,
    //       name: lead.name,
    //       type: lead.type,
    //       email: lead.email,
    //       status: lead.status,
    //       specialization: lead.specialization
    //     }));
    //   })
    // );
  }
  
  addLead(lead: Lead): void {
    const currentLeads = this.leadsSubject.getValue();
    const newLead = {
      ...lead,
      id: this.generateId(currentLeads)
    };
    this.leadsSubject.next([...currentLeads, newLead]);
  }

  deleteLead(id: number): void {
    const currentLeads = this.leadsSubject.getValue();
    this.leadsSubject.next(currentLeads.filter(lead => lead.id !== id));
  }

  updateLead(updatedLead: Lead): void {
    const currentLeads = this.leadsSubject.getValue();
    const updatedLeads = currentLeads.map(lead =>
      lead.id === updatedLead.id ? updatedLead : lead
    );
    this.leadsSubject.next(updatedLeads);
  }

  importLeadsFromCSV(data: any[]): void {
    const currentLeads = this.leadsSubject.getValue();
    const baseId = this.generateId(currentLeads);

    const formattedLeads: Lead[] = data.map((item, index) => ({
      id: baseId + index,
      name: item.name || item.firmName || 'Unknown',
      type: item.type || 'Entity',
      email: item.email || item.firmEmail || '',
      status: item.status || 'New',
      specialization: item.specialization || item.areaOfSpecialization || 'NA'
    }));

    this.leadsSubject.next([...currentLeads, ...formattedLeads]);
  }

  private generateId(leads: Lead[]): number {
    return leads.length > 0 ? Math.max(...leads.map(lead => lead.id || 0)) + 1 : 1;
  }
}